import React from 'react'
import '../JobDetail.css';
import ChatImage from '../../../assets/images/user-icon4.png'

const ChatUser = ({ data, id }) => {

  const updatedAt = data.updated_at;
  const date = new Date(updatedAt);
  const formattedDate = date.toLocaleDateString("en-GB").replace(/\//g, "-");
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const formattedDateTime = `${formattedDate} ${formattedTime}`;

  return (
    <div className='main-chat-section'>
      <div className='chat-wrapper'>
        <img src={ChatImage} alt='image' />
        <div className="user-name-section">
          <p className='p-name'>{data?.business?.businessName}</p>
          <p className='p-content'>{data?.business?.description}</p>
        </div>
      </div>
      <p className='view-job-chat-time' style={{width:'100%'}}>{formattedDateTime}</p>
    </div>
  )
}

export default ChatUser 
